import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@constants/queryKeys.constant';
import { EStaleTime } from '@enums/staleTime.enum';

import { agentsService } from './service';

export function agentsListQueryOptions() {
  return queryOptions({
    queryFn: () => agentsService.list(),
    queryKey: queryKeys.agents.list(),
    staleTime: EStaleTime.FiveMinutes,
  });
}

export function agentDetailQueryOptions(agentId: string) {
  return queryOptions({
    queryFn: () => agentsService.getById(agentId),
    queryKey: queryKeys.agents.detail(agentId),
    staleTime: EStaleTime.FiveMinutes,
  });
}

export function agentCallsQueryOptions(agentId: string) {
  return queryOptions({
    queryFn: () => agentsService.listCalls(agentId),
    queryKey: queryKeys.agents.calls(agentId),
    staleTime: EStaleTime.TwoMinutes,
  });
}

export function agentCapabilitiesQueryOptions() {
  return queryOptions({
    queryFn: () => agentsService.getCapabilities(),
    queryKey: queryKeys.agents.capabilities(),
    staleTime: EStaleTime.OneHour,
  });
}

export function agentConfigurationQueryOptions(agentId: string) {
  return queryOptions({
    queryFn: () => agentsService.getConfiguration(agentId),
    queryKey: queryKeys.agents.configuration(agentId),
    staleTime: EStaleTime.FiveMinutes,
  });
}

export function agentEditorDataQueryOptions(agentId: string) {
  return queryOptions({
    queryFn: () => agentsService.getEditorData(agentId),
    queryKey: queryKeys.agents.editorData(agentId),
    staleTime: EStaleTime.FiveMinutes,
  });
}

export function knowledgeBasesQueryOptions() {
  return queryOptions({
    queryFn: () => agentsService.getKnowledgeBases(),
    queryKey: queryKeys.agents.knowledgeBases(),
    staleTime: EStaleTime.OneHour,
  });
}

export function agentKnowledgeSelectionQueryOptions(agentId: string) {
  return queryOptions({
    queryFn: () => agentsService.getKnowledgeSelection(agentId),
    queryKey: queryKeys.agents.knowledgeSelection(agentId),
    staleTime: EStaleTime.FiveMinutes,
  });
}

export function agentVersionsQueryOptions(agentId: string) {
  return queryOptions({
    queryFn: () => agentsService.listVersions(agentId),
    queryKey: queryKeys.agents.versions(agentId),
    staleTime: EStaleTime.FiveMinutes,
  });
}
